import React from 'react'
import styled from "styled-components";

import FabButton from './fabButton';
import LinksWrapper from './linksWrapper';
import { AppearRight } from './animations';

const FabWrapper = styled.nav`
    position: fixed;
    z-index: 100;
    width: ${props => props.isActive? '75%' : '0'};
    height: 100%;
    bottom: 0;
    right: 0;
    background: #111;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
    transition: all .3s ease;
`;

class MobNav extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      fabIsActive: false
    }
  }

  toggleFab = () => {
    this.setState({
      fabIsActive: !this.state.fabIsActive
    })
  }

  itemSelected = () => {
    setTimeout(() => {
      this.setState({ fabIsActive: false });
    }, 500);
  }

  render(){
    return(
      <FabWrapper isActive={this.state.fabIsActive}>
        <FabButton toggleFab={this.toggleFab} isActive={this.state.fabIsActive} />
        <LinksWrapper handleItem={this.itemSelected} isActive={this.state.fabIsActive} />
      </FabWrapper>
    )
  }
}

export default MobNav



// WEBPACK FOOTER //
// ./src/components/MobNav/index.js